export enum Status {
  Ready,
  Loading,
  Done,
}
